export type BridgeSound = 'start' | 'select' | 'wrong' | 'timeout' | 'build' | 'drive' | 'complete' | 'game-over';

export class BridgeAudio {
  private context?: AudioContext;
  private master?: GainNode;

  unlock() {
    if (!this.context) {
      const Context = window.AudioContext
        ?? (window as Window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
      if (!Context) return;
      this.context = new Context();
      this.master = this.context.createGain();
      this.master.gain.value = 0.16;
      this.master.connect(this.context.destination);
    }
    if (this.context.state === 'suspended') void this.context.resume();
  }

  play(sound: BridgeSound) {
    this.unlock();
    const context = this.context;
    const master = this.master;
    if (!context || !master || context.state !== 'running') return;
    const notes: Record<BridgeSound, readonly number[]> = {
      start: [220, 330, 440], select: [520], wrong: [210, 150], timeout: [240, 180, 120],
      build: [280, 360, 460, 620], drive: [92, 110, 138], complete: [440, 554, 659, 880],
      'game-over': [220, 165, 110],
    };
    notes[sound].forEach((frequency, index) => {
      const startsAt = context.currentTime + index * 0.075;
      const oscillator = context.createOscillator();
      const gain = context.createGain();
      oscillator.type = sound === 'wrong' || sound === 'timeout' || sound === 'game-over' ? 'sawtooth' : 'triangle';
      oscillator.frequency.setValueAtTime(frequency, startsAt);
      gain.gain.setValueAtTime(sound === 'drive' ? 0.05 : 0.11, startsAt);
      gain.gain.exponentialRampToValueAtTime(0.001, startsAt + (sound === 'drive' ? 0.2 : 0.18));
      oscillator.connect(gain).connect(master);
      oscillator.start(startsAt);
      oscillator.stop(startsAt + 0.22);
    });
  }
}
